import React from 'react';

import styles from './ReportsToast.scss';

type ReportsToastContentProps = Omit<React.ComponentProps<'div'>, 'className' | 'style'>;

const ReportsToastContent = React.forwardRef<HTMLDivElement, ReportsToastContentProps>(
  ({ children, ...props }, ref) => (
    <div ref={ref} {...props}>
      {children}
    </div>
  )
);

const ReportsToastText = React.forwardRef<HTMLParagraphElement, React.ComponentProps<'p'>>(
  ({ children, ...props }, ref) => (
    <p className={styles.text} ref={ref} {...props}>
      {children}
    </p>
  )
);

const Content = ReportsToastContent;
const Text = ReportsToastText;

const RootClassName = styles.toastRoot;
const ContainerClassName = styles.toastContainer;
const IconClassName = styles.toastIcon;

export {
  ReportsToastContent,
  ReportsToastText,
  //
  Content,
  Text,
  //
  RootClassName,
  ContainerClassName,
  IconClassName,
};
